module.exports = __webpack_public_path__ + "static/media/grady-booch.94f5147b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/grady-booch.png
// module id = 237
// module chunks = 0